import * as signalR from '@microsoft/signalr';

class NotificationRealtimeService {
    constructor() {
        this.connection = null;
        this.callbacks = new Set();
        this.started = false;
    }

    async start() {
        if (this.started) return;

        this.connection = new signalR.HubConnectionBuilder()
            .withUrl('/hubs/notifications')
            .withAutomaticReconnect()
            .build();

        this.connection.on('notificationPulse', (payload) => {
            this.callbacks.forEach((callback) => callback(payload));
        });

        await this.connection.start();
        this.started = true;
    }

    async stop() {
        if (!this.connection || !this.started) return;
        await this.connection.stop();
        this.started = false;
    }

    onPulse(callback) {
        if (callback) this.callbacks.add(callback);
    }

    offPulse(callback) {
        if (callback) this.callbacks.delete(callback);
    }
}

export default new NotificationRealtimeService();
